import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=382ff0e1&"
import script from "./DefaultChart.vue?vue&type=script&lang=ts&"
export * from "./DefaultChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports